import axios from 'axios';

class HaBikes {
  debugMode = true;
  postID;
  mdlBikeService;
  mdlTitle;
  txtBike;
  txtAreaService;
  txtAreaRemarks;
  inpKm;
  inpService;
  currentKm;
  btnSave;
  btnOpen;

  constructor() {
    if (document.getElementById('bikeview')) {
      if (this.debugMode) console.log('HaBikes.js constructor *start*');

      axios.defaults.headers.common['X-WP-Nonce'] = harzadventureData.nonce;

      this.mdlBikeService = document.getElementById('bikeserviceInfo');
      this.txtAreaService = document.getElementById('bikeservice');
      this.inpKm = document.getElementById('inputKM');
      this.inpService = document.getElementById('inputService');
      this.btnSave = document.getElementById('btnSave');
      this.mdlTitle = this.mdlBikeService.querySelector('.modal-title');
      this.txtBike = this.mdlBikeService.querySelector('.bike');
      this.txtAreaRemarks = document.getElementById('bikeremarks');

      this.txtAreaRemarks.setAttribute('readonly', 'true');

      this.events();
      //this.modalSettings();
      if (this.debugMode) console.log('HaBikes.js constructor *end*');
    }
  }

  events() {
    if (this.debugMode) console.log('HaBikes.js events *start*');

    this.mdlBikeService.addEventListener(
      'show.bs.modal',
      this.modalSettings.bind(this)
    );

    this.mdlBikeService.addEventListener(
      'shown.bs.modal',
      this.modalOptimize.bind(this)
    );

    this.inpKm.addEventListener('input', this.valKmInput.bind(this));

    this.btnSave.addEventListener('click', this.saveService.bind(this));

    if (this.debugMode) console.log('HaBikes.js events *end*');
  }

  modalSettings(e) {
    if (this.debugMode) console.log('HaBikes.js modalSettings *start*');
    // Button that triggered the modal
    this.btnOpen = e.relatedTarget;
    // Extract info from data-bs-* attributes
    this.postID = this.btnOpen.getAttribute('data-bs-id');
    console.log('PostID: ' + this.postID);
    var title =
      '<i class="fa-solid fa-wrench fas-wrench"></i> ' +
      this.btnOpen.getAttribute('data-bs-msgtitle');
    console.log('Titel: ' + this.btnOpen.getAttribute('data-bs-msgtitle'));
    var bike = this.btnOpen.getAttribute('data-bs-bike');
    var service = this.btnOpen.getAttribute('data-bs-bikeservice');
    var remarks = this.btnOpen.getAttribute('data-bs-remarks');
    this.currentKm = this.btnOpen.getAttribute('data-bs-currentKM');

    this.mdlTitle.innerHTML = title;
    this.txtBike.innerHTML = `<strong>${bike}</strong> - <span id="currentKM">${this.currentKm}</span> km`;
    this.txtAreaService.value = service;
    this.txtAreaRemarks.value = remarks;
    this.inpKm.style.border = '1px solid #ced4da';

    this.inpKm.value = '';
    this.inpService.value = '';

    this.valKmInput();

    console.log(e.relatedTarget);

    if (this.debugMode) console.log('HaBikes.js modalSettings *end*');
  }

  modalOptimize(e) {
    if (this.debugMode) console.log('HaBikes.js modalOptimize *start*');

    var maxHeight = 200;

    this.inpKm.focus();

    this.txtAreaService.style.height =
      Math.min(maxHeight, this.txtAreaService.scrollHeight).toString() + 'px';
    this.txtAreaService.scrollTop = this.txtAreaService.scrollHeight;

    if (this.debugMode) console.log('HaBikes.js modalOptimize *end*');
  }

  valKmInput(e) {
    if (this.debugMode) console.log('HaBikes.js valKmInput *start*');

    if (this.isValidInteger(this.inpKm.value, this.currentKm)) {
      this.btnSave.classList.remove('disabled');
      this.txtAreaRemarks.removeAttribute('readonly');
    } else {
      this.btnSave.classList.add('disabled');
      this.txtAreaRemarks.setAttribute('readonly', 'true');
    }

    if (this.debugMode) console.log('HaBikes.js valKmInput *end*');
  }

  saveService(e) {
    if (this.debugMode) console.log('HaBikes.js saveService *start*');

    this.updateUI();
    this.updateBike();

    if (this.debugMode) console.log('HaBikes.js saveService *end*');
  }

  async updateBike() {
    console.log('updateBike: ' + this.postID);
    var ourUpdatedPost = {
      acf: {
        maintenance_info: this.txtAreaService.value,
        km_date: this.niceCurrentDate('US'),
        km: this.currentKm,
        remarks: this.txtAreaRemarks.value,
      },
    };
    try {
      const response = await axios.post(
        harzadventureData.root_url + '/wp-json/wp/v2/bike/' + this.postID,
        ourUpdatedPost
      );
      console.log('Bike in der Datenbank erfolgreich aktualisiert.');
    } catch (e) {
      console.log('Sorry, das Bike konnte nicht gespeichert werden.');
      console.log(e);
    }
  }

  updateUI() {
    if (this.debugMode) console.log('HaBikes.js updateUI *start*');

    //Update Form
    this.currentKm = this.inpKm.value;
    document.getElementById('currentKM').innerText = this.currentKm;
    this.btnSave.classList.add('disabled');

    if (!this.inpService.value == '') {
      var newLine = `${this.niceCurrentDate()} - ${this.currentKm} km - ${
        this.inpService.value
      }`;
      this.txtAreaService.value == ''
        ? (this.txtAreaService.value = newLine)
        : (this.txtAreaService.value += '\r\n' + newLine);
    }
    this.inpKm.value = '';
    this.inpService.value = '';
    this.txtAreaRemarks.setAttribute('readonly', 'true');

    //Update Table
    document.getElementById('kmdate-' + this.postID).innerText =
      this.niceCurrentDate();
    document.getElementById('km-' + this.postID).innerText = this.currentKm;
    this.btnOpen.setAttribute('data-bs-bikeservice', this.txtAreaService.value);
    this.btnOpen.setAttribute('data-bs-remarks', this.txtAreaRemarks.value);
    this.btnOpen.setAttribute('data-bs-currentKM', this.currentKm);

    this.modalOptimize();

    if (this.debugMode) console.log('HaBikes.js updateUI *end*');
  }

  isValidInteger(str, min) {
    var n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= min;
  }

  niceCurrentDate(format = 'DE') {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    var joined;

    if (format == 'DE') {
      joined = [day, month, year].join('.');
    } else {
      joined = [year, month, day].join('-');
    }
    return joined;
  }
}

export default HaBikes;
